import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const LoginSignupPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { user, login, error: authError, loading: authLoading } = useAuth();

  const ADMIN_PASSWORD = "000128";

  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
    setLoading(false);
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      await login(email, password, 'auto');
      navigate("/dashboard");
      return;
    } catch (error) {
      console.error(error.message);
      setError("Invalid email or password. Please try again.");
    }
  };

  const handleAdminAccess = () => {
    const enteredPassword = prompt("Enter admin password:");
    if (enteredPassword === ADMIN_PASSWORD) {
      navigate("/create-account");
    } else {
      alert("Incorrect password!");
    }
  };

  if (loading || authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-900 to-blue-700">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6 bg-gradient-to-r from-blue-900 to-blue-700">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-6 text-center">Sign In</h1>
        <form onSubmit={handleLogin} className="bg-white p-6 rounded-xl shadow-lg">
          {(error || authError) && (
            <div className="bg-red-50 border border-red-200 text-red-600 p-4 rounded-lg mb-6">
              {error || authError}
            </div>
          )}
          <div className="relative mb-6">
            <label className="block mb-2">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="border p-3 w-full rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your email"
            />
          </div>
          <div className="relative mb-6">
            <label className="block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="border p-3 w-full rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your password"
            />
          </div>
          <div className="flex justify-between items-center mb-6">
            <button
              type="button"
              onClick={() => navigate('/forgot-password')}
              className="text-blue-700 hover:text-blue-900 font-medium underline"
            >
              Forgot password?
            </button>

            <button
              type="submit"
              className="bg-blue-600 text-white font-bold p-3 rounded-lg hover:bg-blue-700"
            >
              Sign In
            </button>
          </div>
        </form>
        <div className="mt-6 text-center">
          <p className="text-white">
            Don't have an account?{" "}
            <button
              onClick={handleAdminAccess}
              className="text-white hover:text-blue-200 font-medium underline"
            >
              Create Recruiter Account
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginSignupPage;